import { FormatterType } from '@components/Table/types';
import useQueryObject from '@hooks/useQueryObjectSql';

const useMappingFileFieldTypes = (wfId: undefined | string, dsiId: undefined | string) =>
  useQueryObject({
    queryObject: {
      sorting: [],
      select: {
        dims: [
          {
            name: 'DESCRIBE_JSON(rawlogs.document)',
            alias: 'structure',
          },
        ],
        metrics: [],
      },
      filter: {
        and: {
          operands: [
            {
              expression: {
                fieldName: "AVALOR_CONTEXT(rawlogs, 'workflowId')",
                stringCondition: {
                  equals: wfId,
                },
              },
            },
            ...(dsiId
              ? [
                  {
                    expression: {
                      fieldName: 'rawlogs.dsi_id',
                      stringCondition: {
                        equals: dsiId,
                      },
                    },
                  },
                ]
              : [
                  {
                    or: {
                      operands: [
                        {
                          expression: {
                            fieldName: 'rawlogs.dsi_id',
                            stringCondition: {
                              equals: '',
                            },
                          },
                        },
                        {
                          expression: {
                            fieldName: 'rawlogs.dsi_id',
                            stringCondition: {
                              empty: {},
                            },
                          },
                        },
                      ],
                    },
                  },
                ]),
          ],
        },
      },
      groupBy: [],
      projectionId: {
        name: 'rawlogs.limited',
        builtIn: true,
      },
      top: {
        size: 3000,
        groupOthers: false,
      },
      distinct: true,
    },
    onSuccess: d =>
      d.reduce((acc, { structure: field }) => {
        acc[field.path] = typeToFormatterResolver[field.type] || typeToFormatterResolver.STRING;
        return acc;
      }, {}),
    onError: () => {},
    options: { enabled: !!wfId },
  });

const typeToFormatterResolver = {
  INTEGER: FormatterType.number,
  DECIMAL: FormatterType.number,
  BOOLEAN: FormatterType.boolean,
  ARRAY: FormatterType.array,
  OBJECT: FormatterType.json,
  VARCHAR: FormatterType.string,
  STRING: FormatterType.string,
};

export default useMappingFileFieldTypes;
